import { privateClient } from '.';

const path = '/apolices';

async function CriaApolice(dados) {
	return await privateClient({
		path: `${path}`,
		params: {
			method: 'POST',
			body: JSON.stringify(dados),
		},
	});
}

async function ConsultaApolicePelaId(id) {
	return await privateClient({
		path: `${path}/${id}`,
	});
}

async function ListaApolices() {
	return await privateClient({
		path: `${path}`,
	});
}

async function RemoveApolicePelaId(id) {
	return await privateClient({
		path: `${path}/${id}`,
		params: {
			method: 'DELETE',
		},
	});
}

const apolices = {
	CriaApolice,
	ConsultaApolicePelaId,
	ListaApolices,
	RemoveApolicePelaId,
};

export default apolices;
